<template>
  <v-container v-if="itemToUpdate">
    <v-row>
      <v-col v-bind="cardFormColsProps">
        <v-card v-bind="cardProps">
          <v-card-title v-bind="cardTitleProps">Editar item</v-card-title>
          <v-card-text>
            <v-form v-model="editarItemForm">
              <v-select
                background-color="primary"
                color="secondary"
                rounded
                filled
                dense
                :items="tiposItem"
                item-value="id"
                item-text="title"
                v-model="itemToUpdate.fk_idCatTipoItem"
                :rules="required"
              >
                <template v-slot:label>Tipo de item <span class="red--text">*</span> </template>
              </v-select>
              <v-text-field v-model="itemToUpdate.item" v-bind="textInputProps" :rules="required">
                <template v-slot:label>Nombre del item <span class="red--text">*</span> </template>
              </v-text-field>
            </v-form>
          </v-card-text>
          <v-card-actions v-bind="cardActionsProps">
            <v-btn v-bind="secondaryButtonProps" to="/equipamiento/items">Cancelar</v-btn>
            <v-btn v-bind="primaryButtonProps" :disabled="!editarItemForm || loading" v-on:click="triggerUpdateItem()"
              >Editar item</v-btn
            >
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import {
  cardActionsProps,
  cardFormColsProps,
  cardProps,
  cardTitleProps,
  primaryButtonProps,
  secondaryButtonProps,
  textInputProps,
} from '../../components/props/props'

import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  props: {
    id: {
      type: Number,
    },
  },

  async mounted() {
    this.SET_ITEM_TO_UPDATE(this.id)
  },

  data() {
    return {
      cardFormColsProps,
      cardProps,
      cardTitleProps,
      cardActionsProps,
      primaryButtonProps,
      secondaryButtonProps,
      textInputProps,

      loading: false,
      editarItemForm: false,

      required: [(v) => !!v || 'Este campo es requerido.'],
    }
  },

  computed: {
    ...mapGetters('tipoItem', {
      tiposItem: 'getTiposItem',
    }),

    ...mapGetters('item', {
      itemToUpdate: 'getItemToUpdate',
    }),
  },

  methods: {
    ...mapActions('item', ['updateItem']),
    ...mapMutations('item', ['SET_ITEM_TO_UPDATE']),
    ...mapActions('tipoItem', ['fetchTiposItem']),

    triggerUpdateItem: async function () {
      this.loading = true

      await this.updateItem(this.itemToUpdate)
      await this.fetchTiposItem()

      this.$router.replace('/equipamiento/items')
      this.loading = false
    },
  },
}
</script>
